import { RouterProvider } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
// Importar de `antd/es/locale/...` e não de `antd/locale/...`: o segundo resolve
// para o build CJS e o interop do Vite entrega `{ default: {...} }`, que o
// ConfigProvider ignora em silêncio: toda a interface do AntD (paginação, date
// picker, select) fica em inglês num sistema escolar brasileiro.
import ptBR from 'antd/es/locale/pt_BR';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

import { AuthProvider } from '@/contexts/AuthContext';
import { router } from '@/rotas';
import { theme, antdTheme, GlobalStyles } from '@/styles';
import { ConsentLgpdGate } from '@/components/lgpd/ConsentLgpdGate';

dayjs.locale('pt-br');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <ConfigProvider locale={ptBR} theme={antdTheme}>
      <AntdApp message={{ top: 80, maxCount: 3 }}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <RouterProvider router={router} />
              <ConsentLgpdGate />
            </AuthProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
